import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { NavLink } from 'react-router-dom';

import engine from '../Support/Engine';

import StandardField from '../UI/StandardField';
import Processing from '../UI/Processing';

class RegisterForm extends Component {

	state = {
		form: {
			firm_name: {
				name: 'Firm Name',
				kind: 'text',
				error: false,
				errormsg: '',
				value: ''
			},
			username: {
				name: 'Username',
				kind: 'text',
				error: false,
				errormsg: '',
				value: ''
			},
			email: {
				name: 'Email Address',
				kind: 'email',
				error: false,
				errormsg: '',
				value: ''
			},
			password: {
				name: 'Password',
				kind: 'password',
				error: false,
				errormsg: '',
				value: ''
			},
			password_confirm: {
				name: 'Confirm Password',
				kind: 'password',
				error: false,
				errormsg: '',
				value: ''
			},
			state: {
				name: 'State',
				kind: 'select',
				error: false,
				errormsg: '',
				value: 'State',
				options: ['State', 'Australian Capital Territory', 'New South Wales', 'Northern Territory', 'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia']
			},
			agree: {
				name: 'I agree to the Terms & Conditions above',
				kind: 'check',
				error: false,
				errormsg: '',
				value: false
			}
		},
		processing: false,
		haserror: false,
		result: 0,
		message: '',
		doRedirect: false
	}


	steFieldChanged = (event, field) => {

		const updatedForm = {
			...this.state.form
		};

		const updatedElement = {
			...this.state.form[field]
		};

		if(field === 'agree') {
			updatedElement.value = event.target.checked;
		}
		else if(field === 'username') {
			updatedElement.value = event.target.value.toLowerCase().replace(/[^a-z0-9_]+/gi, '');
		}
		else {
			updatedElement.value = event.target.value;
		}
		updatedForm[field] = updatedElement;

		this.setState({form: updatedForm});

	}


	register = () => {

		const updatedState = {
			...this.state,
			form: {
				...this.state.form
			},
			processing: true,
			result: 0,
			haserror: false,
			message: ''
		};

		const email_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const new_account = {};

		for(let f in this.state.form) {

			const updatedField = {
				...this.state.form[f],
				error: false,
				errormsg: ''
			};

			switch(f) {
				case 'email':
					if(!email_regex.test(updatedField.value)) {
						updatedField.error = true;
						updatedField.errormsg = 'Please enter a valid email address';
						updatedState.haserror = true;
					}
					else {
						new_account.email = updatedField.value;
					}
					break;
				case 'username':
					if(updatedField.value.length < 4) {
						updatedField.error = true;
						updatedField.errormsg = 'Please enter a username with at least 4 characters';
						updatedState.haserror = true;
					}
					else {
						new_account.username = updatedField.value;
					}
					break;
				case 'password':
					if(updatedField.value.length < 6) {
						updatedField.error = true;
						updatedField.errormsg = 'Please enter a password with at least 6 characters';
						updatedState.haserror = true;
					}
					else {
						new_account.password = updatedField.value;
					}
					break;
				case 'password_confirm':
					if(updatedField.value !== updatedState.form.password.value) {
						updatedField.error = true;
						updatedField.errormsg = 'Passwords do not match';
						updatedState.haserror = true;
					}
					break;
				case 'state':
					if(updatedField.value === updatedField.options[0]) {
						updatedField.error = true;
						updatedField.errormsg = 'Please select a ' + updatedField.name.toLowerCase();
						updatedState.haserror = true;
					}
					else {
						new_account.state = updatedField.value;
					}
					break;
				case 'agree':
					if(!updatedField.value) {
						updatedField.error = true;
						updatedField.errormsg = 'You must accept the terms & conditions to continue';
						updatedState.haserror = true;
					}
					else {
						new_account.agree = true;
					}
					break;
				default:
					if(updatedField.value === '') {
						updatedField.error = true;
						updatedField.errormsg = 'Please enter a ' + updatedField.name.toLowerCase();
						updatedState.haserror = true;
					}
					else {
						new_account[f] = updatedField.value;
					}
					break;
			}

			updatedState.form[f] = updatedField;

		}

		this.setState(updatedState);

		if(updatedState.haserror) {
			updatedState.processing = false;
			return false;
		}

		engine.post('/account/register/', new_account)
			.then(packet => {
				let r = -1;
				if(packet.data.result === true) {
					setTimeout(() => {
						this.setState({...this.state, doRedirect: true});
					}, 3000);
					r = 1;
				}
				this.setState({...this.state, processing: false, result: r, message: packet.data.response});
			})
			.catch(error => {
				this.setState({...this.state, processing: false, result: -1, message: 'Sorry, an unexpected error occured.'});
			});

	}


	render() {

		if(this.state.doRedirect) {
			return <Redirect to='/dashboard' />;
		}

		let fields = Object.keys(this.state.form)
			.map(field => {

				let classes = 'account-form__field';
				let errorLine = null;

				if(this.state.form[field].error && this.state.form[field].errormsg !== '') {
					classes += ' account-form__field--has-error';
					errorLine = <span className='account-form__field__error'>{this.state.form[field].errormsg}</span>;
				}

				return (
					<li key={field} className={classes}>
						<StandardField id={field} f={this.state.form[field]} handler={(event) => this.steFieldChanged(event,field)} />
						{errorLine}
					</li>
				);
			});

		let button = <div className='account-form__control__line'><button className='btn btn--full' onClick={this.register}>Sign up</button></div>;
		if(this.state.processing) button = <div className='account-form__control__line'><Processing /></div>;
		else if(this.state.result > 0) button = null;

		let serverResponse = null;
		if(this.state.result !== 0) {
			let srClass = 'account-form__control__line';
			if(this.state.result > 0) {
				srClass += ' account-form__control__line--positive';
				// Redirect to login page after a few seconds
			}
			if(this.state.result < 0) srClass += ' account-form__control__line--negative';
			serverResponse = <p className={srClass}>{this.state.message}</p>;
		}

		return (
			<div className='account-form'>
				<h5 className='account-form__title'>Request</h5>
				<ul className='account-form__fields'>
					{fields}
				</ul>
				<div className='account-form__control'>
					{button}
					{serverResponse}
					<p className='account-form__control__line'><NavLink to='/dashboard'>Already have an account?</NavLink></p>
				</div>
			</div>
		);
	}

}

export default RegisterForm;


// WEBPACK FOOTER //
// ./src/Blocks/RegisterForm.js